import { Component, OnInit, Inject     } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DialogsReturnCode             } from 'src/app/enums/dialogs/returnCode.enum';
import { HandlerManager                } from 'src/app/managers/handler/handler.manager';
import { LoadingManager                } from 'src/app/managers/loading/loading.manager';
import { SessionManager                } from 'src/app/managers/session/session.manager';
import { User                          } from 'src/app/beans/login/user/user.bean';
import { Result } from 'src/app/beans/result/result.bean';
import { SlotModelAuto } from 'src/app/beans/slot-model/slot-model.auto.bean';
import { SlotModel } from 'src/app/beans/slot-model/slot-model.bean';
import { Organization } from 'src/app/beans/organization/organization.bean';

@Component
({
  selector: 'slot.model.dialog',
  templateUrl: './slot.model.dialog.html',
  styleUrls: ['./slot.model.dialog.scss'],
})

export class SlotModelDialog implements OnInit 
{
  public  slotModel : any

  list : any

  types = [
    {
        id : 10,
        name : "Sito"
    }
  ]

  constructor
  (
    private dialogRef : MatDialogRef<SlotModelDialog>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    
    private _handler : HandlerManager,
    private _loader  : LoadingManager,
    private _session : SessionManager,
  ) {}

  ngOnInit(): void
  {
    const user  = this._session.user().get()

    if((user as User).level > 10)
        this.types = [
            {
                id : 10,
                name : "Sito"
            },
            {
                id : 20,
                name : "Organizzazione"
            }
        ]

    this.init()
  }

  async init()
  {
    this.slotModel = this.data
    this.getList()
  }

  //---------------------------------------------------------------------------------------------------

  async getList()
  {
      
    this.list = null
    const user  = this._session.user().get()

    if ( !User.isKind(user) ) return // TODO handle user incorrect 

    let response

    this._loader.start()    

    switch(this.slotModel.type)
    {
        case 10:
            response = await this._handler.site().list( (user as User).token, this.slotModel.orgId, 1)
        break;
        case 20:
            response = await this._handler.organization().list((user as User).token, 1)
        break;
        
    }
        

    this._loader.stop()

    if (!response) return 

    this.list = ( response as any ).list
  }

  async update()
  {
    let response 

    if(this.slotModel.id == null)
      response = await this.create()
    else
      response = await this.changeValue()

    if(!Result.isKind(response))
      return

    response = response as Result
    this.dialogRef.close
    ( 
      {
        code: DialogsReturnCode.SLOTMODEL_MODEL
      }
    )
     
    
  }

  cancel()
  {
    this.dialogRef.close
    ( 
      {
        code: DialogsReturnCode.OPERATION_DECLINED
      }
    )
  }

  //---------------------------------------------------------------------------------------------------

  async changeValue ()
  {
    const user  = this._session.user().get()    
     
    let slotModel = {
        id : this.slotModel.id,
        name : this.slotModel.name,
        note : this.slotModel.note,
        enabled : this.slotModel.enabled,
        siteId : this.slotModel.type == 10 ? this.slotModel.typeId : null,
        orgId : this.slotModel.type == 20 ? this.slotModel.typeId : null,
        period : 7
    }
    

    if ( !User.isKind(user) ) return

    this._loader.start()

    let response = await this._handler.slotModel().update((user as User).token, slotModel)

    this._loader.stop()

    return response
  }

  async create ()
  {
    const user  = this._session.user().get()    
     
    let slotModel = {
        id : null,
        name : this.slotModel.name,
        note : this.slotModel.note,
        enabled : this.slotModel.enabled,
        siteId : this.slotModel.type == 10 ? this.slotModel.typeId : null,
        orgId : this.slotModel.type == 20 ? this.slotModel.typeId : null,
        period : 7
    }
    

    if ( !User.isKind(user) ) return

    this._loader.start()

    let response = await this._handler.slotModel().create((user as User).token, slotModel)

    this._loader.stop()

    return response
  }

  //---------------------------------------------------------------------------------------------------

}
